module.exports = __webpack_public_path__ + "img/icon-interpersonal-title.0f628bc8.png";